import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Fragment, useCallback, useEffect, useState } from 'react';
import { JhiItemCount, JhiPagination, Translate, getSortState, translate } from 'react-jhipster';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Table } from 'reactstrap';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import DoNotShowInProduction from 'app/shared/components/do-not-show-in-production/do-not-show-in-production.component';
import { PageFilters } from 'app/shared/components/page-filters/PageFilters';
import { PageHeader } from 'app/shared/components/page-header/PageHeader';
import { ISearchTypes } from 'app/shared/interfaces/searchTypesInterface';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { Loading } from 'app/shared/util/loading';
import { ASC, DEFAULT_ITEMS_PER_PAGE, DESC } from 'app/shared/util/pagination.constants';
import { getEntities } from './device-sensor.reducer';

export const DeviceSensor = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();

  const totalItems = useAppSelector(state => state.deviceSensor.totalItems);
  const loading = useAppSelector(state => state.deviceSensor.loading);
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(props.location, DEFAULT_ITEMS_PER_PAGE, 'id'), props.location.search)
  );

  const deviceSensorList = useAppSelector(state => state.deviceSensor.entities);
  const [nameSearch, setNameSearch] = useState<string>('');

  const searchTypes: ISearchTypes[] = [
    {
      label: translate('fleetSenseApp.deviceSensor.deviceTruckImplement'),
      placeholder: translate('fleetSenseApp.deviceSensor.search'),
      value: nameSearch,
      setValue: setNameSearch,
    },
  ];

  const getAllEntities = useCallback(() => {
    dispatch(
      getEntities({
        page: paginationState.activePage - 1,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
        nameSearch,
      })
    );

    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (props.location.search !== endURL) {
      props.history.replace(`${props.location.pathname}${endURL}`);
    }
  }, [paginationState]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const setActivePage = () => {
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
  };

  useEffect(() => {
    getAllEntities();
  }, [getAllEntities]);

  const { match } = props;

  return (
    <Fragment>
      <PageHeader
        headingId="device-sensor-heading"
        headingDataCy="DeviceSensorHeading"
        contentKey="fleetSenseApp.deviceSensor.home.title"
        buttonTextKey="fleetSenseApp.deviceSensor.home.createLabel"
        match={match}
      />

      <PageFilters setActivePage={setActivePage} searchTypes={searchTypes} showFilters={['filters']} />

      {!loading ? (
        <Table responsive>
          <thead>
            <tr>
              <DoNotShowInProduction>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="fleetSenseApp.deviceSensor.id">ID</Translate> <FontAwesomeIcon icon="sort" />
                </th>
              </DoNotShowInProduction>
              <th className="hand" onClick={sort('hardwareKey')}>
                <Translate contentKey="fleetSenseApp.deviceSensor.hardwareKey">Hardware Key</Translate> <FontAwesomeIcon icon="sort" />
              </th>
              <th className="hand" onClick={sort('sensor.name')}>
                <Translate contentKey="fleetSenseApp.deviceSensor.sensor">Sensor</Translate> <FontAwesomeIcon icon="sort" />
              </th>
              <th className="hand" onClick={sort('sensorHardware.equation')}>
                <Translate contentKey="fleetSenseApp.sensorHardware.equation">Sensor Hardware</Translate> <FontAwesomeIcon icon="sort" />
              </th>
              <th className="hand" onClick={sort('deviceTruckImplement.serial')}>
                <Translate contentKey="fleetSenseApp.deviceSensor.deviceTruckImplement">Device Truck Implement</Translate> <FontAwesomeIcon icon="sort" />
              </th>
              <th />
            </tr>
          </thead>
          <tbody>
            {deviceSensorList.map((deviceSensor, i) => (
              <tr key={`entity-${i}`} data-cy="entityTable">
                <DoNotShowInProduction>
                  <td>
                    <Button tag={Link} to={`${match.url}/${deviceSensor.id}`} color="link" size="sm">
                      {deviceSensor.id}
                    </Button>
                  </td>
                </DoNotShowInProduction>
                <td>{deviceSensor.hardwareKey}</td>
                <td>
                  <Link to={`sensor/${deviceSensor?.sensor?.id}`}>{deviceSensor?.sensor?.name}</Link>
                </td>
                <td>
                  <Link to={`sensor-hardware/${deviceSensor?.sensorHardware?.id}`}>{deviceSensor?.sensorHardware?.description}</Link>
                </td>
                <td>
                  <Link to={`device-truck-implement/${deviceSensor?.deviceTruckImplement?.id}`}>{deviceSensor?.deviceTruckImplement?.serial}</Link>
                </td>
                <td className="text-right">
                  <div className="btn-group flex-btn-group-container">
                    <Button
                      tag={Link}
                      to={`${match.url}/${deviceSensor.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                      color="primary"
                      size="sm"
                      data-cy="entityEditButton"
                    >
                      <FontAwesomeIcon icon="pencil-alt" />{' '}
                      <span className="d-none d-md-inline">
                        <Translate contentKey="entity.action.edit">Edit</Translate>
                      </span>
                    </Button>
                    <Button
                      tag={Link}
                      to={`${match.url}/${deviceSensor.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                      color="danger"
                      size="sm"
                      data-cy="entityDeleteButton"
                    >
                      <FontAwesomeIcon icon="trash" />{' '}
                      <span className="d-none d-md-inline">
                        <Translate contentKey="entity.action.delete">Delete</Translate>
                      </span>
                    </Button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <Loading />
      )}
      {!loading && !deviceSensorList.length && (
        <div className="alert alert-warning text-center">
          <Translate contentKey="fleetSenseApp.deviceSensor.home.notFound">No Device Sensors found</Translate>
        </div>
      )}
      {totalItems && !loading && !!deviceSensorList.length ? (
        <div className="count-page">
          <Row>
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </Row>
          <Row>
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </Row>
        </div>
      ) : (
        <Fragment />
      )}
    </Fragment>
  );
};

export default DeviceSensor;
